Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.URLLoaderDataFormat = module.exports.default = {
	BINARY: "binary",
	TEXT: "text",
	VARIABLES: "variables"
};